"use client";

import React from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const cuandoAplica = ["Ya hay infraestructura construida — sea por Fulcro o por otro proveedor — y la fase intensiva de construcción terminó.", "Lo que se necesita es que lo construido siga vivo, no que crezca más.", "Hay tolerancia cero a depender de una sola persona que sabe cómo funciona el sistema.", "La operación ya rinde y meterle más superficie técnica sin razón es agregar costo, no valor."];
export default function CuandoAplicaSoporte() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="soporte-cuando-aplica" id="cuando-aplica-soporte" className="bg-background text-foreground py-24 md:py-32 overflow-hidden border-t border-border/30">
      <div className="container mx-auto px-6 md:px-8 max-w-4xl">
        <div ref={ref} className={`transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <h2 className="font-serif text-3xl md:text-4xl lg:text-5xl font-normal text-foreground leading-tight mb-8">
            Cuándo aplica.
          </h2>

          <p className="font-sans text-lg text-muted-foreground leading-relaxed mb-10 max-w-2xl">
            Soporte es el servicio correcto cuando:
          </p>

          <ul className="space-y-5 mb-10 max-w-2xl">
            {cuandoAplica.map((item, i) => <li key={i} className="flex gap-4 font-sans text-base md:text-lg text-foreground/90 leading-relaxed">
                <span className="font-mono text-primary text-sm mt-1.5 shrink-0">
                  ·
                </span>
                <span>{item}</span>
              </li>)}
          </ul>

          <p className="font-sans text-base md:text-lg italic text-muted-foreground leading-relaxed max-w-2xl">
            Si todavía hay frente abierto de construcción significativa, el servicio correcto es Partner. Soporte es para fase estable.
          </p>
        </div>
      </div>
    </section>;
}